// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import "./CreateGasPrice.css";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import Loader from "../../../Utilities/Loader/Loader";
// import axios from 'axios';

export default function CreateGasprice({ show, closeModal, refreshPage }) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    max_quantity: "",
    min_quantity: "",
    discount: "",
    price: "",
    status: ""
  });

  const resetForm = () => {
    setFormData({
      max_quantity: "",
      min_quantity: "",
      discount: "",
      status: ""
    });
    setValidationError({});
  };

  const handleChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    axiosInstance
      .post(`/admin/gas-pricings`, formData)
      .then((response) => {
        toast.success(response.data.data.message);
        refreshPage();
        handleClose();
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
        if (err.response.status == 422) {
          setValidationError(err.response.data.errors);
        }
        // console.log(err.response.data);
      })
      .finally(() => setIsLoading(false));
  };

  

  useEffect(() => {}, [])

  return (
    <div className="CreateVehicle">
      <Modal show={show} onHide={handleClose}>
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Vehicle Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <Form.Label>Name</Form.Label> */}
            <Form.Group className="mb-3" controlId="formBasicname">
              <div>
                <h6>Min Quantity (Kg)</h6>
              </div>
              <Form.Control
                type="number"
                placeholder=""
                name="min_quantity"
                value={formData.min_quantity}
                onChange={handleChange}
                required
              />
              {validationError.min_quantity && (
                <small className="text-danger my-1">
                  {validationError.min_quantity[0]}
                </small>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicname">
              <div>
                <h6>Max Quantity (Kg)</h6>
              </div>
              <Form.Control
                type="number"
                placeholder=""
                name="max_quantity"
                value={formData.max_quantity}
                onChange={handleChange}
                required
              />
              {validationError.max_quantity && (
                <small className="text-danger my-1">
                  {validationError.max_quantity[0]}
                </small>
              )}
            </Form.Group>
          

            <Form.Group className="mb-3" controlId="formBasicname">
              <div>
                <h6>Price (₦)</h6>
              </div>
              <Form.Control
                type="number"
                placeholder=""
                name="price"
                value={formData.price}
                onChange={handleChange}
                required
              />
              {validationError.price && (
                <small className="text-danger my-1">
                  {validationError.price[0]}
                </small>
              )}
            </Form.Group>

            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              {/* <Form.Label>Description</Form.Label> */}
              <div>
                <h6>Discount (%)</h6>
              </div>
              <Form.Control
                type="number"
                placeholder=""
                name="discount"
                value={formData.discount}
                onChange={handleChange}
                required
              />
              {validationError.discount && (
                <small className="text-danger my-1">
                  {validationError.discount[0]}
                </small>
              )}
            </Form.Group>

           
         
            <div className="mb-3">
              <label htmlFor="status" style={{ display: "block" }}>
                <div>
                  <h6>Status</h6>
                </div>
                <select
                  className="form-control mt-2"
                  id="status"
                  value={formData.status}
                  onChange={handleChange}
                  name="status"
                >
                  <option value="">--Select--</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </label>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="link" onClick={handleClose}>
              Close
            </Button>
            <Button className="custom-primary" type="submit">
              Save
            </Button>
          </Modal.Footer>
        </Form>
        {isLoading && <Loader />}
      </Modal>
    </div>
  );
}
